<template>
  <div class="mb-10">
    <HeaderBar :title="hTitle" />
    <div>
      <img src="../../../../../../assets/images/requirementFromBuyer.png" alt="">
    </div>
  </div>
</template>

<script>
import HeaderBar from "../../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
};
</script>